import React from "react";
import "./App.css";
import { MainView } from "./components/Home/MainView";
import Admin from "./components/Admin/Admin";
import { Routes, Route } from "react-router-dom";
import Footer from "./components/Footer/Footer";
import NavBar from "./components/Navbar/NavBar";
// import './assets/css/prism.css';
// import Prism from "prismjs";
// import MathType from '@wiris/mathtype-ckeditor5';

// ClassicEditor
//     .create( document.querySelector( '#editor' ), {
//         plugins: [ MathType, /* ... */ ],
//         toolbar: [ 'MathType', 'ChemType', /* ... */ ]
//     } )
//     .then( /* ... */ )
//     .catch( /* ... */ );



export default class App extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      readyToTypeset: false,
      adminMode: false,
      mathjaxConfig: {
        startup: {
          ready: () => {
            window.MathJax.startup.defaultReady();
            this.setState({ readyToTypeset: true });
          }
        }
      }
    };
  }


  componentDidMount() {

    const currentLang = localStorage.getItem("lang") ? localStorage.getItem("lang") : "EN"
    localStorage.setItem("lang", currentLang)
    // window.MathJax = this.state.mathjaxConfig;
    // let script = document.createElement("script");
    // script.defer = true;
    // script.src = "https://cdn.jsdelivr.net/npm/mathjax@3/es5/tex-svg.js";
    // document.head.appendChild(script);
    const mode = sessionStorage.getItem("admin", false)
    if (mode == true) {
      this.setState({ adminMode: true })
    } else {
      this.setState({ adminMode: false })
    }
  }
  componentDidUpdate() {
    if (this.state.readyToTypeset)
      window.MathJax.typesetPromise();
  }


  render() {
    return (
      <>
        <Routes>
          <Route
            path="/*"
            element={
              <>
              <NavBar />
                <div
                  className={true ? "vh-100 container" : "fullWidth"}
                  style={{ padding: 0 }}
                >
                  <MainView />
                </div>
                <Footer />

              </>
            }
          />
          <Route
            path="admin/*"
            element={<Admin />}
          />
        </Routes>
      </>
    )
  }
}

